<template>
    <div>
        <b-row class="mt-2">
        <b-col md="8">
            <b-form-group>
            <b-form-input
                v-model="consultarcirugiamedica"
                placeholder="Buscar por nombre o código de la cirugía."
                type="text"
                class="d-inline-block"
            />
            </b-form-group>
        </b-col>
        <b-col md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <b-form-group class="w-100">
                <v-select
                    id="establecimiento"
                    v-model="consultarestablecimiento"
                    :options="establecimientos"
                    placeholder="Buscar por establecimiento."
                    :reduce="option => option.value"
                    label="text"
                    class="d-inline-block w-100"
                />
            </b-form-group>
        </b-col>
        <b-col md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <b-form-group class="w-100">
                <v-select
                    id="especialidad"
                    v-model="consultarespecialidad"
                    :options="especialidades"
                    placeholder="Buscar por especialidad."
                    :reduce="option => option.value"
                    label="text"
                    class="d-inline-block w-100"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <b-button variant="primary" @click="buscarCirugiaMedica">
                    <font-awesome-icon icon="magnifying-glass" style="color: white;"  /> <span style="color: white;">
                    buscar</span>
            </b-button>
        </b-col>
        </b-row>
        <b-overlay
          :show="mostrarLoader"
          opacity="0.50"
          rounded="sm"
        >
            <b-card class="principal">
            <b-col
              cols="12"
              class="pr-0 pl-0 mt-2"
            >
            <b-table
                v-if="items.length > 0"
                bordered
                striped
                responsive
                :current-page="currentPage"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                >
                <template #cell(acciones)="data">
                    <div class="d-flex justify-content-end">
                    <!-- Asegúrate de usar la propiedad correcta aquí, por ejemplo, `idImagen` -->
                    <b-button variant="info" size="sm" @click="viewItem(data.item.token)">
                        <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                    </b-button>
                    <b-button variant="primary" size="sm" @click="editItem(data.item.token)">
                        <font-awesome-icon icon="user-pen" style="color: white;" />
                    </b-button>
                    <b-button variant="danger" size="sm" @click="removeItemid(data.item.idCirugiaMedica)">
                        <font-awesome-icon icon="circle-xmark" style="color: white;" />
                    </b-button>
                    </div>
                </template>
                </b-table>
              <div v-else class="text-center">
                <p>No se encontraron registros</p>
              </div>
            </b-col>

            <b-col
              cols="12"
              class="mb-2"
            >
            <b-pagination
                v-if="items.length > 0"
                v-model="currentPageModificado"
                :total-rows="totalRows"
                :per-page="perPage"
                :small="true"
                first-number
                last-number
                class="mb-0"
                align="center"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambiarPagina"
            >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-card>
        </b-overlay>
        <b-modal v-model="modalShow" @show="cargarComponente" title="Detalles de la Cirugia" size="md">
            <component :is="componenteDinamico" v-if="componenteDinamico" :token="tokenSeleccionado"></component>  
      
    </b-modal>
    </div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BOverlay, 
    BFormGroup, 
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
} from 'bootstrap-vue'
import actions from '@/assets/utils/utils'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export default {
    components: {
        BCard,
        BCardCode,
        BRow,
        BCol, 
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BOverlay,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BTooltip,
        vSelect,
    },
    data() {
        
        return {
            tokenSeleccionado: null,
            modalShow: false,
            componenteDinamico: null,
            pagina_actual:1,
            currentPage: 1,
            currentPageModificado:1,
            mostrarLoader: false,
            login_user: '',
            consultarcirugiamedica:null,
            consultarestablecimiento:'',
            consultarespecialidad:'',
            establecimientos: [],
            establecimiento:'',
            especialidad: '',
            especialidades: [],
            perPage: 15,
            pageOptions: [3, 5, 10],
            totalRows: 3,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fields: [
                

                { key: 'nombre', label: 'Nombre', sortable: true, thClass: 'text-center' },
                { key: 'establecimiento', label: 'Establecimientos', sortable: true, thClass: 'text-center' },
                { key: 'especialidad', label: 'Especialidades', sortable: true, thClass: 'text-center' },
                { key: 'codigo', label: 'Codigo', sortable: true, thClass: 'text-center' },
                { key: 'preciodoc', label: 'Precio Doctor', sortable: true, thClass: 'text-center' },
                { key: 'precioan', label: 'Precio Anestesiologo', sortable: true, thClass: 'text-center' },
                { key: 'usuario', label: 'Usuario', sortable: true, thClass: 'text-center' },
                { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },            
            ],
            listaAcciones: [],
            token_usuario: '',
            configdateTimePicker: {
                enableTime: false,
                dateFormat: 'd/m/Y',
            },
            items: [],
            descripcion: '',
        }
    },
    created() {
        this.comprobarPermisos()
        this.fetchConsultarCirugiaMedica()
        this.setToken();
        this.fetchEstablecimientos();
        this.fetchEspecialidades();

    },
    mounted() {
        actions.setearTitulo('Cirugias Médicas')
    },

    methods: {
       
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            console.log("llegamos ",this.currentPage)
        },
        cambiarPagina(newPage) {
            this.currentPageModificado = newPage;
            this.fetchConsultarCirugiaMedica(this.search, newPage, this.establecimiento, this.especialidad, this.pageSize);
        },
        async fetchEstablecimientos() {
            const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
                    value: item.id,
                    text: item.Descripcion,
                    uniCodigo: item.uniCodigo
                }));
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },

        async fetchEspecialidades() {
            const query = `
                        query {
                            allEspecialidades {
                                id
                                descripcion
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.especialidades = response.data.data.allEspecialidades.map(item => ({
                    value: item.id,
                    text: item.descripcion
                }));
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },

        async fetchConsultarCirugiaMedica(search = '', pagina_actual = this.currentPageModificado, establecimiento = '', especialidad = '', pageSize = this.perPage) {
            console.log("fetchConsultarCirugiaMedica llamado con:", pagina_actual);
            console.log("fetchConsultarCirugiaMedica llamado con2:", pageSize);

            const query = `
            query GetAllCirugiasMedicas($search: String, $establecimiento: String, $page: Int, $pageSize: Int) {
                allCirugiasMedicas(search: $search, establecimiento: $establecimiento, page: $page, pageSize: $pageSize) {
                    total
                    status
                    message
                    cirugiasMedicas {
                        id
                        token
                        nombre
                        codigo
                      usuarioCreador{
                        id
                        username
                      }
                      precioDoctor
                      precioAnestesiologo
                      especialidad{
                        id
                        descripcion
                      }
                        establecimiento {
                            id
                            Descripcion
                        }
                    }
    								
                    pageInfo {
                        currentPage      
                        totalPages
                        hasNextPage
                        hasPreviousPage
                    }
                }
            }
            `;
            const var_consulta = {
                search: search,
                page: pagina_actual,
                pageSize: pageSize,
                establecimiento: establecimiento.toString(),
                especialidad: especialidad.toString()
            }
            try {
                const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });
                console.log(response)

                if (response.status === 200) {
                    if (response.data.data.allCirugiasMedicas.status === 'Success') {
                        if (response.data.data.allCirugiasMedicas.cirugiasMedicas) {
                            this.items = response.data.data.allCirugiasMedicas.cirugiasMedicas.map(item => {
                                return {
                                    idCirugiaMedica: item.id,
                                    token: item.token,
                                    establecimiento: item.establecimiento.Descripcion,
                                    nombre: item.nombre,
                                    codigo: item.codigo,
                                    especialidad: item.especialidad.descripcion,
                                    preciodoc: item.precioDoctor, 
                                    precioan: item.precioAnestesiologo,
                                    usuario: item.usuarioCreador.username
                                };
                            });
                            console.log("yey",this.items);

                            this.currentPageModificado = response.data.data.allCirugiasMedicas.pageInfo.currentPage;
                            this.totalRows = response.data.data.allCirugiasMedicas.total;

                            

                        } else {
                            console.log("No se encontraron cirugias médicas");
                            // Aquí podrías establecer un mensaje en la interfaz de usuario
                        }
                    } else {
                        console.log("Error en la respuesta del servidor");
                        // Manejo del error de respuesta del servidor
                    }
                }
            } catch (error) {
                console.error("Error fetching cirugías médicas:", error);
                // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
            }
        },
        buscarCirugiaMedica() {
            const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
            const especialidadValue = this.consultarespecialidad ? this.consultarespecialidad.toString() : '';
            this.currentPageModificado = 1; // Resetear la página actual a 1 para una nueva búsqueda
            this.fetchConsultarCirugiaMedica(
                this.consultarcirugiamedica ? this.consultarcirugiamedica : '',
                this.currentPageModificado, // Usar currentPageModificado en lugar de currentPage
                establecimientoValue, especialidadValue,
                this.perPage // Usar perPage desde tu componente data
            );
        },

        viewItem(token) {
        this.tokenSeleccionado = token;
        this.modalShow = true;
    },
    cargarComponente() {
      // Cargar dinámicamente el componente cuando se muestra el modal
      import('./Vercirugia.vue').then(componente => {
        this.componenteDinamico = componente.default;
      }).catch(error => {
        console.error('Error al cargar el componente:', error);
      });
    
    }
  ,


        // viewItem(token) {
        //     this.$router.push({
        //         name: 'ver_cirugia',
        //         params: { token: token }
        //     });
        // },

        editItem(token) {
            this.$router.push({
                name: 'editar_cirugia',
                params: { token: token }
            });
        },
        removeItemid(idCirugiaMedica) {
            const mesa = this.fetchRemoveCirugiaMedica(idCirugiaMedica);
        },
        async fetchRemoveCirugiaMedica(idCirugiaMedica) {
            
            this.$swal({
                title: 'Estas seguro de eliminar cirugia medica?',
                text: "No seras capaz de revertir esto!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, Borrar esto!',
                cancelButtonText: 'No, cancelar!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // Call the API or method to remove the item here
                    try {
                        const argCirMed = {
                            id: idCirugiaMedica,
                        }
                        const response = await axios.post(rutas.axios + 'api', {
                            query: `
                            mutation EliminarCirugiaMedica($id: String!) {
                                removerCirugiaMedica(cirugiaMedicaDatos: { id: $id }) {
                                    status
                                    message
                                }
                            }
                                `,
                            variables: argCirMed
                        });
                        if (response.status === 200) {
                            if (response.data.data.removerCirugiaMedica.status === 'success') {
                                if (response.status === 200) {
                                    this.$swal({
                                        title: 'Borrado!',
                                        text: 'Tu registro ha sido eliminado',
                                        icon: 'success',
                                        confirmButtonColor: '#3085d6'
                                    }).then((result) => {
                                        // This will only run when the user presses "OK" on the "Deleted!" modal
                                        if (result.isConfirmed) {
                                            this.$router.go(0);
                                        }
                                    });
                                }
                                this.$router.push({ name: 'consultar_cartera_cirugia' }).catch(err => {
                                    if (err.name !== 'NavigationDuplicated') {
                                        console.error(err);
                                    }
                                });
                            } else {
                                this.$swal({
                                    title: 'Error',
                                    text: response.data.data.removerCirugiaMedica.message,
                                    icon: 'error',
                                    confirmButtonColor: '#089599',
                                })
                            }
                        }
                    } catch (err) {
                        console.log(err);
                        return 'Error al eliminar doctor';
                    }
                } else {
                    // User clicked the cancel button
                    this.$swal({
                        title: 'Cancelado',
                        text: 'Your registro esta seguro :)',
                        icon: 'error',
                        confirmButtonColor: '#3085d6'
                    });
                }
            });
        },
        setToken() {
            const user = JSON.parse(localStorage.getItem('usuario'))
            this.login_user = user.username
            axios.defaults.headers.common.Authorization = `JWT ${user.token}`
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        comprobarPermisos() {
            if (localStorage.getItem('permisos').indexOf('consultar_cita') === -1) {
                this.$router.push({ name: 'not-permitted' })
            }
        },
       
    },
    
}
</script>
